var map = {
	"./Confused.svg": [
		5588,
		588
	],
	"./Frustrated.svg": [
		8720,
		720
	],
	"./Happy.svg": [
		8776,
		776
	],
	"./NoEntry.svg": [
		1928,
		928
	],
	"./Proud.svg": [
		5804,
		804
	],
	"./Relieved.svg": [
		4860,
		860
	],
	"./Sad.svg": [
		5996,
		996
	],
	"./SmilingAnyway.svg": [
		3424,
		424
	],
	"./Stressed.svg": [
		5780,
		780
	],
	"./Tired.svg": [
		8404,
		404
	],
	"./Unsure.svg": [
		6787,
		168
	],
	"./Worried.svg": [
		6212,
		212
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8663;
module.exports = webpackAsyncContext;